<template>
  <!-- <nano-player :name="videoUrl"></nano-player> -->
  <div id="videoplayer"></div>
</template>

<script>
// import NanoPlayer from '~/components/NanoPlayerHls'
export default {
  name: 'LiveMatch',
  // components: {
  //   NanoPlayer
  // },

  props: {
    videoUrl: { type: [String, Number], default: '', required: true }
  },
  mounted() {
    const iframe = document.createElement('iframe')
    // div tag in which iframe will be added should have id attribute with value id videoplayer
    document.getElementById('videoplayer').appendChild(iframe)
    // provide height and width to it
    iframe.setAttribute('style', 'height:100%;width:100%;overflow:hidden')
    iframe.setAttribute('src', this.videoUrl)
    // iframe.contentWindow.document.write(this.videoUrl)
  }
}
</script>
